import React from "react";
import { MenuItem, Spinner } from "@chakra-ui/react";
import { IoLinkOutline } from "react-icons/io5";
import { useToast } from "duck";
import { useResendOrganizationInviteMutation } from "requests";

interface InvitationResendingProps {
  id: number;
}

const InvitationResending: React.FC<InvitationResendingProps> = ({ id }) => {
  const [resend, { loading }] = useResendOrganizationInviteMutation();
  const toast = useToast();

  return (
    <MenuItem
      onClick={() => {
        resend({ variables: { input: { organization: id } } }).then(() => {
          toast({
            description: "Invitation link is resent successfully.",
            status: "success"
          });
        });
      }}
      icon={loading ? <Spinner width={3} height={3} /> : <IoLinkOutline />}
    >
      Resend invitation link
    </MenuItem>
  );
};

export default InvitationResending;
